<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <b-col cols="12" md="6">
                    <ValidationProvider v-slot="{ valid, errors }" name="is_academically_eligible" rules="required">
                        <b-form-group :label="$t('is_academically_eligible')">
                            <yes-no-selectbox
                                :isBoolean="true"
                                v-model="formData.is_academically_eligible"
                                :validate-error="errors[0]"></yes-no-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider v-slot="{ valid, errors }" name="has_completed_session" rules="required">
                        <b-form-group :label="$t('has_completed_session')">
                            <yes-no-selectbox
                                :isBoolean="true"
                                v-model="formData.has_completed_session"
                                :validate-error="errors[0]"></yes-no-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider v-slot="{ valid, errors }" name="is_transfer_out_on_time" rules="required">
                        <b-form-group :label="$t('is_transfer_out_on_time')">
                            <yes-no-selectbox
                                :isBoolean="true"
                                v-model="formData.is_transfer_out_on_time"
                                :validate-error="errors[0]"></yes-no-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
            <div class="d-flex justify-content-center mt-2">
                <processing-button :label="$t('save')" :processing="formLoading" @click="updateForm"/>
            </div>
        </ValidationObserver>
    </div>
</template>

<script>
// Components
import YesNoSelectbox from "@/components/interactive-fields/YesNoSelectbox.vue";
import ProcessingButton from "@/components/elements/ProcessingButton.vue";
// Services
import TransferOutRequestMentora from "@/services/TransferOutRequestMentora";

// Other
import {ValidationProvider, ValidationObserver} from "vee-validate"


export default {
    components: {
        ProcessingButton,
        YesNoSelectbox,
        ValidationProvider,
        ValidationObserver,
    },
    props: {
        formId: {
            type: Number,
        }
    },
    data() {
        return {
            formData: {
                is_academically_eligible: null,
                has_completed_session: null,
                is_transfer_out_on_time: null,
            },
            formLoading: false,
        }
    },
    methods: {
        async updateForm() {
            const isValid = await this.$refs.formModalValidate.validate();
            if (isValid && this.checkPermission('transferoutrequest_saveadminreviews')) {
                this.$swal.fire({
                    title: this.$t('warning'),
                    text: this.$t('leave_of_absence_statement'),
                    showCancelButton: true,
                    confirmButtonText: this.$t('yes'),
                    cancelButtonText: this.$t('no'),
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.formLoading = true
                        TransferOutRequestMentora.saveAdminReview(this.formId, this.formData)
                            .then(response => {
                                this.$emit('updateFormSuccess', true);
                                this.$toast.success(this.$t('api.' + response.data.message));
                            })
                            .catch(error => {
                                this.showErrors(error, this.$refs.formModalValidate)
                            })
                            .finally(() => {
                                this.formLoading = false
                            });
                    }
                })
            }
        }
    }
}
</script>
